module.exports = __webpack_public_path__ + "static/media/Italian_Bianca BG-50.f7a05441.png";